<a class="button" (click)="open()" [ghs-label]=" 'party.sheet'" [ghs-label-attribute]="'title'">
  <span [ghs-label]="gameManager.game.party.name || 'party.sheet'"></span>
</a>